import logger from '@/utils/logger';

export default {
  install(Vue) {
    if (window.mixpanel) {
      Vue.prototype.$trackEvent = (eventName, props = {}) => window.mixpanel.track(eventName, props);
      Vue.prototype.$identify = identity => window.mixpanel.identify(identity);
    } else {
      Vue.prototype.$trackEvent = (eventName, props = {}) => logger.info(`Track event: '${eventName}'`, props); // eslint-disable-line
      Vue.prototype.$identify = identity => logger.info(`Identify: '${identity}'`); // eslint-disable-line
    }
  }
};
